import { useEffect } from 'react';
import { homeAppUrl } from '@goodsteward/gs-ui';
import { Card, CardBody } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';

// Phase 15 retired PMA's Staff / Roles / Parent-Accounts UI — practice
// admins now manage users (and their per-service grants) from the Home
// app. This page lands at /users so bookmarked URLs and stale links
// don't 404; it explains the move and offers a one-click jump to Home.

export function ManageUsersInHomePage() {
    const target = homeAppUrl('pma');

    useEffect(() => {
        document.title = 'User management moved to Home — Good Steward';
    }, []);

    return (
        <div className="p-6 max-w-[680px] mx-auto">
            <h1 className="font-display text-2xl font-bold text-text mb-1">
                Manage users in Home
            </h1>
            <Card>
                <CardBody>
                    <p className="text-sm text-text-muted mb-3">
                        Staff, role, and parent-account management moved to the Home
                        app. This page used to host that surface — there's nothing to
                        do here anymore.
                    </p>
                    <p className="text-sm text-text-muted mb-4">
                        Open Home to add a user, change a role, or grant access to
                        another service.
                    </p>
                    <Button variant="primary" size="sm" onClick={() => { window.location.href = target; }}>
                        Open Home
                    </Button>
                </CardBody>
            </Card>
        </div>
    );
}
